/**
 * GM map settings panel: grid dimensions + background image upload.
 * Plain DOM; the upload itself goes through the caller (needs the GM key).
 */

import type { MapState } from "@asarimitsuha/table-core";

export interface MapPanelCallbacks {
  onApply(settings: {
    widthCells: number;
    heightCells: number;
    cellSizePx: number;
    feetPerCell: number;
  }): void;
  onUploadImage(file: File): void;
  onClearImage(): void;
}

function numberInput(name: string, label: string, value: number): {
  wrap: HTMLElement;
  input: HTMLInputElement;
} {
  const wrap = document.createElement("label");
  wrap.textContent = label;
  const input = document.createElement("input");
  input.type = "number";
  input.name = name;
  input.value = String(value);
  wrap.appendChild(input);
  return { wrap, input };
}

export function renderMapPanel(
  root: HTMLElement,
  map: MapState,
  cb: MapPanelCallbacks,
): void {
  const form = document.createElement("form");
  form.dataset["testid"] = "map-panel";

  const width = numberInput("widthCells", "Width (cells)", map.widthCells);
  const height = numberInput("heightCells", "Height (cells)", map.heightCells);
  const cellPx = numberInput("cellSizePx", "Cell size (px)", map.cellSizePx);
  const feet = numberInput("feetPerCell", "Feet per cell", map.feetPerCell);

  const apply = document.createElement("button");
  apply.type = "submit";
  apply.textContent = "Apply grid";

  form.append(width.wrap, height.wrap, cellPx.wrap, feet.wrap, apply);
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    cb.onApply({
      widthCells: Number(width.input.value),
      heightCells: Number(height.input.value),
      cellSizePx: Number(cellPx.input.value),
      feetPerCell: Number(feet.input.value),
    });
  });

  const upload = document.createElement("input");
  upload.type = "file";
  upload.accept = "image/png,image/jpeg,image/webp";
  upload.dataset["testid"] = "map-upload";
  upload.addEventListener("change", () => {
    const file = upload.files?.[0];
    if (file) cb.onUploadImage(file);
    upload.value = "";
  });

  const clear = document.createElement("button");
  clear.type = "button";
  clear.dataset["testid"] = "map-clear";
  clear.textContent = "Clear image";
  clear.addEventListener("click", () => cb.onClearImage());

  form.append(upload, clear);
  root.appendChild(form);
}
